import rollbarLogger from 'config/rollbar';
import { SamplePointStatisticWithAggregates } from 'types/models/samplePointsStatistic';

export function assertIsSamplePointStatisticWithAggregates(s: any): asserts s is SamplePointStatisticWithAggregates {
  if (!s || !('aggregates' in s)) {
    rollbarLogger.error('Expected a SamplePointStatisticsWithAggregates but received', s);
    throw new Error(`Expected a SamplePointStatisticsWithAggregates but received ${JSON.stringify(s)}`);
  }
};